import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M6,16a1,1,0,0,0-1,1V29a1,1,0,0,0,2,0V17A1,1,0,0,0,6,16Z"/><path d="M9,11H7V3A1,1,0,0,0,5,3v8H3a1,1,0,0,0,0,2H9a1,1,0,1,0,0-2Z"/><path d="M16,17a1,1,0,0,0,1-1V3a1,1,0,0,0-2,0V16A1,1,0,0,0,16,17Z"/><path d="M19,20H13a1,1,0,0,0,0,2h2v7a1,1,0,0,0,2,0V22h2a1,1,0,0,0,0-2Z"/><path d="M26,16a1,1,0,0,0-1,1V29a1,1,0,1,0,2,0V17A1,1,0,0,0,26,16Z"/><path d="M29,11H27V3a1,1,0,0,0-2,0v8H23a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2Z"/>';
export var FiltersSVG = function FiltersSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
FiltersSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(FiltersSVG);